// ----------------------------------------------------------------------

const ROOTS = {
  MAIN: '/',
  AUTH: '/auth',
};

// ----------------------------------------------------------------------

export const paths = {
  minimalUI: 'https://mui.com/store/items/minimal-dashboard/',
  // AUTH
  auth: ROOTS.AUTH,
  // DASHBOARD
  dashboard: {
    root: ROOTS.MAIN,
    properties: '/properties',
    users: '/users',
    whatsapp: '/whatsapp',
    settings: '/settings',
    locations: '/locations',
    onelink: '/onelink',
    features: '/features',
    chat: '/chat',
  },
};
